import { currencyFormatter } from '../../../../../utils';

export const formatCashBack = (cashBack) =>
    cashBack !== null && cashBack !== undefined ? ` ${currencyFormatter.format(cashBack)} ` : null;
